
import React from "react";
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { useFormContext } from "react-hook-form";
import FileUpload from "@/components/agent-upload/FileUpload";
import PublicToggle from "@/components/agent-upload/PublicToggle";
import { AgentFormData } from "@/models/agent-form";

const PublishSection: React.FC = () => {
  const form = useFormContext<AgentFormData>();

  return (
    <div className="space-y-6">
      <FormField
        control={form.control}
        name="file"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Agent File</FormLabel>
            <FormControl>
              <FileUpload
                file={field.value}
                error={form.formState.errors.file?.message as string | undefined}
                onFileChange={(file) => field.onChange(file)}
              />
            </FormControl>
            <p className="text-xs text-muted-foreground mt-1">
              Upload your agent code. We support .js, .ts, .json, .py, .txt, .md, and .zip files.
            </p>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <FormField
        control={form.control}
        name="isPublic"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Visibility</FormLabel>
            <FormControl>
              <PublicToggle
                isPublic={field.value}
                onChange={(checked) => field.onChange(checked)}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};

export default PublishSection;
